import React, { useState, useEffect } from 'react'
import FetchApi from '../../customhooks/functionFetchApi';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';

const Addregisterbom = () => {
    let { id } = useParams();
    const FetchApis = new FetchApi();

    const nameRegister = sessionStorage.getItem('UserName');
    const employeedId = sessionStorage.getItem('EmCode');
    const departId = sessionStorage.getItem('DepartId');
    const [datalistAll, setDatalistAll] = useState([]);



    const [datalist, setDatalist] = useState({
        journalId: id, nameregister: nameRegister, employeeId: employeedId, departcode: departId, typeregister: "",
        active_type: 0, itemBom: "", detaillist: "", dateupdate: "", tdscode: "", datetime_approved: ""
    })

    useEffect(() => {
        let dateNew = datenow();
        getregisterbomlist(dateNew);
        getlistRegisterall()

    }, []);

    function savebom(e) {
        e.preventDefault()
        FetchApis.FethcPost(`/registerbom/CreateRegisterBom`, datalist).then(res => {
            console.log(res)
            if (res) {
                getlistRegisterall()
            }
        })
    }

    function onCheckText(e) {
        var { name, value, type, checked } = e.target;

        setDatalist({
            ...datalist, [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
        })
    }

    function getregisterbomlist(dateNow) {
        FetchApis.FethcGet(`/journal/journalbyId/${id}`).then(res => {
            if (res) {
                var datajour = res.data.data[0];
                setDatalist({
                    ...datalist,
                    tdscode: datajour.tdscode,
                    itemBom: datajour.itemname,
                    dateupdate: dateNow,
                    datetime_approved: datajour.datetime_approved || ""
                })
            }
        })
    }

    function getlistRegisterall() {
        FetchApis.FethcGet(`/registerbom/getRegisterbomByJourId/${id}`).then(res => {
            if (res) {
                setDatalistAll(res.data.data)
            }
        })
    }


    function deleteBomById(ID) {
        Swal.fire({
            title: "แจ้งเตือน ?",
            text: "คุณต้องการจะลบข้อมูลนี้ ใช่หรือไม่!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete !"
        }).then((result) => {
            if (result.isConfirmed) {

                FetchApis.FethcDelete(`/registerbom/deleteById/${ID}`).then(res => {
                    if (res) {
                        getlistRegisterall()
                        Swal.fire({
                            title: "Deleted!",
                            text: "คุณได้ทำการลบเรียบร้อยแล้ว .",
                            icon: "success"
                        });
                    }
                })

            }
        });

    }

    function datenow() {
        let ts = Date.now();

        let date_ob = new Date(ts);
        let date = date_ob.getDate();
        let month = date_ob.getMonth() + 1;
        let year = date_ob.getFullYear();
        if (date < 10) {
            date = "0" + date
        }
        if (month < 10) {
            month = "0" + month
        }

        let nowdate = year + "-" + month + "-" + date;
        return nowdate;
    }


    return (
        <div style={{ margin: 10, padding: 5, }}>
            <form onSubmit={(e) => savebom(e)}>
                <div style={{ padding: 10, backgroundColor: '#E9967A' }}>เพิ่ม ข้อมูลการสร้าง Bom & Route</div>
                <div style={{
                    width: '100%', padding: 20, flexDirection: 'column', backgroundColor: '#E8E8E8',
                    justifyContent: 'center', alignContent: 'center', display: 'flex'
                }}>

                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 2, marginBottom: 3 }}>
                        <div style={{ width: 200 }}>Journal Code :</div>
                        <div>
                            <input type='text' name='tdscode' value={datalist.tdscode} placeholder=' version bom & route' style={{ width: 300 }} disabled />
                        </div>
                        <div style={{ marginLeft: 10 }}>
                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 2 }}>
                                <div style={{ width: 100 }}>Item name :</div>
                                <div>
                                    <input type='text' name='itemBom' value={datalist.itemBom} placeholder=' item name' style={{ width: 350 }} disabled />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 2, marginBottom: 3 }}>
                        <div style={{ width: 200 }}>Datetime Approved :</div>
                        <div>
                            <input type='text' name='datetime_approved' value={datalist.datetime_approved} placeholder=' datetime approved' style={{ width: 300 }} disabled />
                        </div>
                    </div>

                    <div style={{ flexDirection: 'row', display: 'flex', marginBottom: 3, alignItems: 'center' }}>
                        <div style={{ width: 200 }}>ประเภท Bom / Route :</div>
                        <div>
                            <select name='typeregister' id="typeregister" style={{ width: 250, height: 30 }} onChange={(e) => onCheckText(e)}>
                                <option value="">เลือกรายการ</option>
                                <option value="bom">Bom</option>
                                <option value="route">Route</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 20 }}>
                            <input type='checkbox' name='active_type'
                                checked={datalist.active_type === 1}
                                onChange={(e) => onCheckText(e)} />
                            <label style={{ margin: 0 }}>ยืนยัน</label>
                        </div>
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 2 }}>
                        <div style={{ width: 200 }}>รายละเอียด :</div>
                        <div>
                            <input name='detaillist'
                                value={datalist.detaillist}
                                placeholder=' รายละเอียด' style={{ width: 500 }} maxLength={200} onChange={(e) => onCheckText(e)} />
                        </div>
                    </div>

                    <div style={{ flexDirection: 'row', display: 'flex', marginTop: 10, justifyContent: 'center' }}>
                        <button type='submit' style={{
                            padding: '5px 20px', borderRadius: 5, borderColor: '#4CAF50',
                            backgroundColor: '#4CAF50', color: '#fff', fontSize: 14, cursor: 'pointer'
                        }}>บันทึก</button>
                    </div>
                </div>
            </form>
            <div style={{ marginTop: 10 }}>
                {datalistAll.map((item, index) => (
                    <div key={index} style={{
                        border: '1px solid #d0d0d0', borderRadius: 8, marginBottom: 16,
                        overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                    }}>
                        {/* Card Header */}
                        <div style={{
                            backgroundColor: item.typeregister === 'bom' ? '#4a90d9' : '#7b5ea7',
                            padding: '8px 14px', display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                <span style={{
                                    backgroundColor: '#fff', color: item.typeregister === 'bom' ? '#4a90d9' : '#7b5ea7',
                                    borderRadius: 4, padding: '2px 10px', fontWeight: 700, fontSize: 13, textTransform: 'uppercase'
                                }}>
                                    {item.typeregister}
                                </span>
                                <span style={{ color: '#fff', fontSize: 13 }}>
                                    รหัส : <strong>{item.active_type}</strong>
                                </span>
                            </div>
                            <button style={{
                                padding: '3px 12px', borderRadius: 5, border: 'none',
                                backgroundColor: '#e74c3c', color: '#fff', fontSize: 13, cursor: 'pointer'
                            }} onClick={() => deleteBomById(item.bomId)}>
                                ลบข้อมูล
                            </button>
                        </div>

                        {/* Detail */}
                        {item.detaillist && (
                            <div style={{ padding: '8px 14px', fontSize: 13, color: '#444', borderBottom: '1px solid #e8e8e8' }}>
                                <span style={{ color: '#888', marginRight: 6 }}>รายละเอียด :</span>
                                {item.detaillist}
                            </div>
                        )}

                        {/* Card Footer */}
                        <div style={{
                            backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0',
                            padding: '6px 14px', display: 'flex', gap: 24, fontSize: 12, color: '#555'
                        }}>
                            <span>ผู้ลงทะเบียน : <strong>{item.nameregister}</strong></span>
                            <span>แผนก : <strong>{item.departments}</strong></span>
                            <span>วันที่บันทึก : <strong>{item.dateupdate}</strong></span>
                        </div>
                    </div>
                ))}
            </div>

            {/* <DataTable
                columns={columns}
                data={datajourlist}
                // selectableRows
                pagination
                customStyles={customStyles}
                highlightOnHover
            /> */}

        </div>
    )
}

export default Addregisterbom